import React from 'react';
import css from './EditListingPricingPagePackagesList.css';
import {
    LISTING_PACKAGE_ANONYM_LISTING_ID,
    LISTING_PACKAGE_PRIVATE_LISTING_ID,
    LISTING_PACKAGE_SOCIAL_BOOST_ID,
    PROFILE_PACKAGE_ANONYM_PROFILE_ID,
    PROFILE_PACKAGE_PRIVATE_PROFILE_ID,
    PROFILE_PACKAGE_SOCIAL_BOOST_ID,
    extraPackagesListingConfig,
    extraPackagesProfileConfig,
} from '../../marketplace-custom-config';
import ExtraPackage from '../BoostingPackages/ExtraPackage';
import { getSmallestPackagePrice } from '../../util/extraPackages';
import classNames from 'classnames';
import AlertNotEnoughCredits from './AlertNotEnoughCredits';

const EditListingPricingPagePackagesList = ({
    rootClassName,
    currentUser,
    currentListing,
    values = {},
    renderSubmitButton,
    packagesType,
    disabled,
}) => {
    if (!currentUser?.id?.uuid) return null;

    const {
        publicData: { userType },
        privateData: { creditsAvailable = {} },
    } = currentUser.attributes.profile;

    const isDisabled = packageId =>
        disabled || (creditsAvailableByType < config[packageId].price && !values[packageId]);

    const isProfilePackageType = packagesType === 'profile';
    const config = isProfilePackageType ? extraPackagesProfileConfig : extraPackagesListingConfig;
    const creditsAvailableByType = creditsAvailable[userType];
    const smallestPackagePrice = getSmallestPackagePrice(config);
    const lessThanSmallestPackagePrice = creditsAvailableByType < smallestPackagePrice;

    const socialBoostPackageId = isProfilePackageType
        ? PROFILE_PACKAGE_SOCIAL_BOOST_ID
        : LISTING_PACKAGE_SOCIAL_BOOST_ID;
    const anonymPackageId = isProfilePackageType
        ? PROFILE_PACKAGE_ANONYM_PROFILE_ID
        : LISTING_PACKAGE_ANONYM_LISTING_ID;
    const privatePackageId = isProfilePackageType
        ? PROFILE_PACKAGE_PRIVATE_PROFILE_ID
        : LISTING_PACKAGE_PRIVATE_LISTING_ID;

    const somePackageSelected =
        values[socialBoostPackageId] || values[anonymPackageId] || values[privatePackageId];

    return (
        <>
            {lessThanSmallestPackagePrice && <AlertNotEnoughCredits />}

            <section
                className={classNames(css.packagesSection, {
                    [rootClassName]: !!rootClassName,
                })}
            >
                <ExtraPackage
                    price={config[socialBoostPackageId].price}
                    id={socialBoostPackageId}
                    currentListing={currentListing}
                    disabled={isDisabled(socialBoostPackageId)}
                    isProfilePackageType={isProfilePackageType}
                >
                    <ExtraPackage.Category>Sichtbarkeit</ExtraPackage.Category>
                    <ExtraPackage.Block>
                        <ExtraPackage.IconBoosting />
                        <ExtraPackage.UpperSection>
                            <ExtraPackage.TitleAndPrice title="Social Boost" />
                            <ExtraPackage.Checkbox />
                        </ExtraPackage.UpperSection>
                        <ExtraPackage.Description>
                            Mehr Reichweite über Facebook und Instagram.
                        </ExtraPackage.Description>
                        <ExtraPackage.Footer>
                            <ExtraPackage.Badge color="success">
                                + 500% Sichtbarkeit
                            </ExtraPackage.Badge>
                            <ExtraPackage.Badge />
                        </ExtraPackage.Footer>
                    </ExtraPackage.Block>
                </ExtraPackage>
                <ExtraPackage
                    price={config[privatePackageId].price}
                    id={privatePackageId}
                    currentListing={currentListing}
                    disabled={isDisabled(privatePackageId)}
                    isProfilePackageType={isProfilePackageType}
                >
                    <ExtraPackage.Block>
                        <ExtraPackage.IconPrivateHorse />
                        <ExtraPackage.UpperSection>
                            <ExtraPackage.TitleAndPrice
                                title={`Privates ${isProfilePackageType ? 'Profil' : 'Profil'}`}
                            />
                            <ExtraPackage.Checkbox />
                        </ExtraPackage.UpperSection>
                        <ExtraPackage.Description>
                            {isProfilePackageType
                                ? 'Vollständige Unsichtbarkeit in der Suche, der Karte und bei Ansichten.'
                                : 'Vollständige Unsichtbarkeit in der Suche, der Karte und bei Ansichten.'}
                        </ExtraPackage.Description>
                        <ExtraPackage.Footer>
                            <div />
                            <ExtraPackage.Badge />
                        </ExtraPackage.Footer>
                    </ExtraPackage.Block>
                </ExtraPackage>
                <ExtraPackage
                    price={config[anonymPackageId].price}
                    id={anonymPackageId}
                    currentListing={currentListing}
                    disabled={isDisabled(anonymPackageId)}
                    isProfilePackageType={isProfilePackageType}
                >
                    <ExtraPackage.Category>Datenschutz</ExtraPackage.Category>
                    <ExtraPackage.Block>
                        <ExtraPackage.IconAnonymHorse />
                        <ExtraPackage.UpperSection>
                            <ExtraPackage.TitleAndPrice
                                title={`Anonymes ${isProfilePackageType ? 'Profil' : 'Profil'}`}
                            />
                            <ExtraPackage.Checkbox />
                        </ExtraPackage.UpperSection>
                        <ExtraPackage.Description>
                            Namen, Fotos und Videos bleiben bis zu einem Match verborgen.
                        </ExtraPackage.Description>
                        <ExtraPackage.Footer>
                            <div />
                            <ExtraPackage.Badge />
                        </ExtraPackage.Footer>
                    </ExtraPackage.Block>
                </ExtraPackage>

                {typeof renderSubmitButton === 'function'
                    ? renderSubmitButton({
                          somePackageSelected,
                          disabled: lessThanSmallestPackagePrice,
                      })
                    : null}
            </section>
        </>
    );
};

export default EditListingPricingPagePackagesList;
